import { useEffect } from 'react';
import {
  queryDiagrams,
  resetDiagramPagination,
} from '../store/dashboardActions';
import DashboardLayout from '../components/DashboardLayout';
import { useOrganizationStore } from '../../../shared/organization/organizationStore';
import { listenToOrgChangesAction } from '../../../shared/organization/organizationActions';
import { useAuth } from '../../../hooks/useAuth';
import { useAuthStore } from '../../auth/authStore';

const Dashboard = () => {
  const org = useOrganizationStore((state) => state.organization);
  const { user, loading } = useAuth();
  const auth = useAuthStore((state) => state.auth);
  useEffect(() => {
    if (!user || loading || !auth) {
      return;
    }
    queryDiagrams();

    return () => {
      resetDiagramPagination();
    };
  }, [user, loading, auth]);

  useEffect(() => {
    if (!org || !org.id) {
      return;
    }
    listenToOrgChangesAction(org.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [org?.id]);

  return <DashboardLayout />;
};

export default Dashboard;
